import script from "./SettingsItemTags.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemTags.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemTags.vue?vue&type=style&index=0&id=6338ac9a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6338ac9a"]])

export default __exports__